import styled from 'styled-components';
import { useState } from 'react';
import tw from 'twin.macro';

const SwitchLabel = styled.label<{ $active?: boolean, $disabled?: boolean }>`
  position: relative;
  width: 60px;
  height: 34px;
  box-sizing: content-box;
  border-radius: 34px;
  transition: all 0.25s;
  ${({ $active }) => !$active ? `background: rgba(0,0,0,0.2)` : `background: green`};
    ${({ $disabled }) => $disabled && `cursor: not-allowed`};


`;

const Checkbox = styled.input`
    display: none;
`
const SwitchButton = styled.button<{ $active?: boolean, $disabled?: boolean }>`
    position: absolute;
    border-radius: 100%;
    width: 30px;
    height: 30px;
    background: white;
    top: 2px;
    transition: all 0.25s;
    box-shadow: 0px 0px 5px rgba(0,0,0,0.4);
    ${({ $active }) => !$active ? `left: 2px` : `left: 28px`};
        ${({ $disabled }) => $disabled && `cursor: not-allowed`};

`;

const Wrapper = styled.div`
  width: 100%;
  font-size: 12px;
    ${tw`flex items-center justify-start gap-2 flex-col`}
`;

const TopWrapper = styled.div`
${tw`flex flex-col gap-2`}`;



interface SwitchProps {
    title?: string;
    description?: string;
    disabled?: boolean;
    value?: boolean;
    onSwitch?: (value: boolean) => void;
}

export default function Switch({ title, description, disabled, value=false, onSwitch }: SwitchProps) {

    const [active, setActive] = useState(value);

    function triggerSwitch() {
        setActive(!active);
        if(onSwitch){
            onSwitch(active);
        }
    }
    return (<Wrapper>
        <TopWrapper>
            <span><b>{title}</b></span>
            <span>{description}</span>
        </TopWrapper>
        <SwitchLabel $active={active} $disabled={disabled}>
            <Checkbox />
            <SwitchButton $active={active} onClick={triggerSwitch} disabled={disabled} $disabled={disabled} />
        </SwitchLabel>
    </Wrapper>);
}